<template>
  <div class="rt-list-dropdown">
    <el-dropdown trigger="click" @command="handleCommand">
      <div class="rt-list-dropdown-content" @click="dropdownClick">
        <p class="rt-list-dropdown-title">{{ menuList[selected].name }}</p>
        <rt-icon
          :name="showMore ? 'rt-base-angle_up' : 'rt-base-angle_down'"
          size="16"
        />
      </div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in menuList"
          :icon="item.icon"
          :key="index"
          :command="index"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'RtListDropdown',
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showMore: false,
      selected: this.value
    };
  },
  computed: {
    hasIcon() {
      return !!this.icon;
    }
  },
  watch: {
    value(newValue) {
      this.selected = newValue;
    }
  },
  methods: {
    dropdownClick() {
      this.showMore = !this.showMore;
    },
    handleCommand(val) {
      this.showMore = false;
      this.$emit('input', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtListDropdown.vue?dadbc078